import { Component } from '@angular/core';

@Component({
  selector: 'app-nari',
  templateUrl: './nari.component.html',
  styleUrls: ['./nari.component.css']
})
export class NariComponent {

}
